/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { Card, Layout, Caption, TextStyle, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { URL } from 'src/constants/links';
import knowledgeBase01 from 'src/assets/images/dashboard/knowledgebase2_01.png';
import knowledgeBase02 from 'src/assets/images/dashboard/knowledgebase2_02.png';
import knowledgeBase03 from 'src/assets/images/dashboard/knowledgebase1_03.png';

import withBlockCanDismiss from './blockCanDismiss';

type Props = {
  renderPopover: () => void
};

type ComposedProps = Props & WithI18nProps;
class guideToKnowledgeBaseAppEngagement extends Component<ComposedProps> {
  render() {
    const { renderPopover, i18n } = this.props;

    const knowledgeBase = [
      {
        src: knowledgeBase01,
        title: i18n.translate('AdminHTML.Dashboard.Common.knowledgeBase01'),
        content: i18n.translate(
          'AdminHTML.Dashboard.GuideToKnowledgeBaseAppEngagement.knowledgeBase1_Content'
        ),
        href: URL['KnowledgeBase2_01'],
        actionLabel: 'Knowledge Base 01'
      },
      {
        src: knowledgeBase02,
        title: i18n.translate('AdminHTML.Dashboard.Common.knowledgeBase02'),
        content: i18n.translate(
          'AdminHTML.Dashboard.GuideToKnowledgeBaseAppEngagement.knowledgeBase2_Content'
        ),
        href: URL['KnowledgeBase2_02'],
        actionLabel: 'Knowledge Base 02'
      },
      {
        src: knowledgeBase03,
        title: i18n.translate('AdminHTML.Dashboard.Common.knowledgeBase03'),
        content: i18n.translate(
          'AdminHTML.Dashboard.Common.themeSetupInsightsForBoostProductFilterAndSearchUsers'
        ),
        href: URL['KnowledgeBase2_03'],
        actionLabel: 'Knowledge Base 03'
      }
    ];

    return (
      <div className="BC-KnowledgeBase__Dashboard">
        <Card>
          <Card.Header title={i18n.translate('AdminHTML.Dashboard.Common.guideToKnowledgeBase')}>
            <div className="BC-Block-Dismiss--Right-Menu">{renderPopover()}</div>
          </Card.Header>
          <Card.Section>
            <Layout>
              {knowledgeBase.map((item, index) => (
                <Layout.Section oneThird key={index}>
                  <div className="knowledgeBox">
                    <Card>
                      <Link removeUnderline url={item.href} external>
                        <img className="full-width" src={item.src} alt={item.title} />
                        <Card.Section>
                          <Caption>
                            <TextStyle variation="strong">
                              <span className="guide">{item.content}</span>
                            </TextStyle>
                          </Caption>
                        </Card.Section>
                      </Link>
                    </Card>
                  </div>
                </Layout.Section>
              ))}
            </Layout>
          </Card.Section>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = dispatch => ({});

export default withBlockCanDismiss(
  connect(mapStateToProps, mapDispatchToProps)(withI18n()(guideToKnowledgeBaseAppEngagement))
);
